import { render, staticRenderFns } from "./PropertyMaintenanceItemDialog.vue?vue&type=template&id=0084fafa"
import script from "./PropertyMaintenanceItemDialog.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceItemDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports